import React, { useState } from 'react'
import MainLayout from '../components/MainLayout'
import ReportGridPage from '../components/ReportGridPage';
import { downloadAttachmentHeader } from '../components/HeaderAttribute';

const DownloadAttachments = () => {
  const [answerQuestions, setAnswerQuestions] = useState([
    {
      QuestionsNo: "1.1",
      AnswerNo: "1",
      Attachment: "AnswerOne.pdf",
      Questions:
        "Does your company formally and publicly adhere to any external CSR initiatives or sets of principles?",
    },
    {
      QuestionsNo: "1.1",
      AnswerNo: "2",
      Attachment: "ethosflologo.jpeg",
      Questions:
        "Does your company formally and publicly adhere to any external CSR initiatives or sets of principles?",
    },
    {
      QuestionsNo: "1.1",
      AnswerNo: "3",
      Attachment: "AnswerTwo.jpeg",
      Questions:
        "Does your company formally and publicly adhere to any external CSR initiatives or sets of principles?",
    },
    {
      QuestionsNo: "1.1",
      AnswerNo: "4",
      Attachment: "amswerlogo.jpeg",
      Questions:
        "Does your company formally and publicly adhere to any external CSR initiatives or sets of principles?",
    },
    {
      QuestionsNo: "1.2",
      AnswerNo: "1",
      Attachment: "questionanswer.pdf",
      Questions:
      "Has your company been audited by an independent external auditor regarding sustainability issue(s) (e.g. environment, labor & human rights, ethics, sustainable procurement), at one or more of your company's locations? If yes, upload the audit report and/or Corrective Action Plan Report that show the latest non-compliance result. Each report's publication date must be within two years of your questionnaire's submission date.",
    },
    {
      QuestionsNo: "1.2",
      AnswerNo: "2",
      Attachment: "ethosflologo.jpeg",
      Questions:
        "Has your company been audited by an independent external auditor regarding sustainability issue(s) (e.g. environment, labor & human rights, ethics, sustainable procurement), at one or more of your company's locations? If yes, upload the audit report and/or Corrective Action Plan Report that show the latest non-compliance result. Each report's publication date must be within two years of your questionnaire's submission date.",
    },
    {
      QuestionsNo: "1.2",
      AnswerNo: "3",
      Attachment: "ethosflologo.jpeg",
      Questions:
      "Has your company been audited by an independent external auditor regarding sustainability issue(s) (e.g. environment, labor & human rights, ethics, sustainable procurement), at one or more of your company's locations? If yes, upload the audit report and/or Corrective Action Plan Report that show the latest non-compliance result. Each report's publication date must be within two years of your questionnaire's submission date.",
    },
  ]);
    const [selectedRowData, setSelectedRowData] = useState([]);
    const [selectedRowTableData, setSelectedRowTableData] = useState([]);
    const [checkBoxStatus, setCheckBoxStatus] = useState(false);
  return (
    <MainLayout pageName={"4"}>
     <ReportGridPage
          title="Download Attachment"
          header={downloadAttachmentHeader}
          records={answerQuestions}
          onSelectedGrid={setSelectedRowData}
          selectedRowTableData={selectedRowTableData}
          checkBoxStatus={setCheckBoxStatus}
        />
    </MainLayout>
  )
}

export default DownloadAttachments